import { z } from 'zod';
export const urlOptionsSchema = z.object({});
export const urlCellSchema = z.string();
//# sourceMappingURL=url.js.map